import {BreadCrumbs} from "../../../components/open/pages";
import '../../../static/css/pages/students/students.css';
import {
    SearchIcon,
    ThinAddIcon,
    ThinClassIcon, ThinCloudDownloadIcon,
    ThinCloudUploadIcon,
    ThinEditIcon,
    ThinFilterIcon,
    ThinOpenNewIcon,
    ThinTrashIcon,
} from "../../../components/icons/material-icons";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Link, useNavigate} from "react-router-dom";
import {ReactSpreadsheetImport} from "react-spreadsheet-import";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {CurrencyFormat, FixStringWithNumbers} from "../../../components/techaran/money";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {AddEditStudentModal} from "./add-edit-student";
import {Apis} from "../../../components/api/url";
import {RemoveModal} from "../../../components/template/remove-modal";
import {SelectClassModal} from "../classes/select-class-modal";
import {AdminsStudentsProfileFilterModal} from "./student-profile-filter";

interface studentInterface {
    id: number,
    firstname: string,
    lastname: string,
    grade: number,
    className: string,
    classId: number,
    national: string,
    father: string,
}

interface printStudentsInterface {
    id: number,
    firstname: string,
    lastname: string,
    grade: number,
    national: string,
    father: string, // name
    birthSerial: string,
    homeTell: string,
    birthDate: string,
    fatherCertificate: string,
    fatherTell: string,
    fatherJob: string,
    motherName: string,
    motherTell: string,
    motherCertificate: string,
    motherJob: string,
    zipCode: string,
    address: string,
    budget: number,
    maxBuyPerDay: number,
    IsInside: 0 | 1,
    className: string,
    classId: number,
}

export const AdminsStudentsListScreen = () => {
    const [list, setList] = useState([] as studentInterface[]);
    const [loaded, setLoaded] = useState(false);
    const [can,setCans] = useState({
        remove:false,
        addEdit:false,
        download:false,
    })
    const [renderExcel, setRenderExcel] = useState(false);
    const [profileFilter, setProfileFilter] = useState('all' as 'all' | 'complete' | 'incomplete');
    const navigate = useNavigate();
    const fetchList = (classId: number, profile: 'all' | 'complete' | 'incomplete') => {
        setProfileFilter(profile);
        PostJSON(
            Apis.server + '/core/admins/students/list',
            {
                classId: classId,
                profile: profile,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: studentInterface[] | null,
                canAdd:boolean,
                canRemove:boolean,
                canDownload:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setCans({
                    remove: d.canRemove,
                    addEdit: d.canAdd,
                    download:d.canDownload,
                });
                setLoaded(true);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        let _grades = [] as string[];
        for (let i = 1; i <= 12; i++)
            _grades.push(GradeToString(i));
        setGrades([..._grades]);
        document.title = "دانش‌آموزان | نهال";
        fetchList(0, 'all');
    }, []);
    const saveExcelData = (data: any) => {
        const invalidData = data.invalidData;
        const validData = data.validData;
        if (invalidData.length > 0) {
            ShowSnackbar('لطفا ستون‌های اجباری را به درستی تکمیل کنید.', 'باشه', 5000);
            return;
        }
        let final: {
            firstName: string,
            lastName: string,
            national: string,
            grade: number,
            birthSerial: string,
            homeTell: string,
            birthDate: string, // gregorian
            fatherName: string,
            fatherCert: string,
            fatherTell: string,
            fatherJob: string,
            motherName: string, // full name
            motherTell: string,
            motherCert: string,
            motherJob: string,
            zipcode: string,
            address: string,
        }[] = [];
        validData.forEach((v: any) => {
            let birth = typeof v['birthDate'] === "string" ? v.birthDate : '13900101';
            // if (/^\d{8}$/.test(birth))
            birth = birth.slice(0, 4) + '-' + birth.slice(4, 6) + '-' + birth.slice(6)
            // let greg = DateFixToGoLayout(birth);
            let greg = PersianToGregorian(birth);
            final.push({
                firstName: typeof v['firstName'] === "string" ? v.firstName : '',
                lastName: typeof v['lastName'] === "string" ? v.lastName : '',
                national: FixStringWithNumbers(typeof v['national'] === "string" ? (v.national.length === 9 ? `0${v.national}` : v.national) : ''),
                grade: typeof v['grade'] === "string" ? GradeToNumber(v.grade) : 0,
                birthSerial: FixStringWithNumbers(typeof v['birthSerial'] === "string" ? v.birthSerial : ''),
                homeTell: FixStringWithNumbers(typeof v['homeTell'] === "string" ? v.homeTell : ''),
                birthDate: greg,
                fatherName: typeof v['fatherName'] === "string" ? v.fatherName : '',
                fatherCert: typeof v['fatherCert'] === "string" ? v.fatherCert : '',
                fatherTell: FixStringWithNumbers(typeof v['fatherTell'] === "string" ? (v.fatherTell.length === 10 && v.fatherTell[0] !== '0' ? `+98${v.fatherTell}` : v.fatherTell) : ''),
                fatherJob: typeof v['fatherJob'] === "string" ? v.fatherJob : '',
                motherName: typeof v['motherName'] === "string" ? v.motherName : '',
                motherTell: FixStringWithNumbers(typeof v['motherTell'] === "string" ? v.motherTell : ''),
                motherCert: typeof v['motherCert'] === "string" ? v.motherCert : '',
                motherJob: typeof v['motherJob'] === "string" ? v.motherJob : '',
                zipcode: FixStringWithNumbers(typeof v['zipcode'] === "string" ? v.zipcode : ''),
                address: FixStringWithNumbers(typeof v['address'] === "string" ? v.address : ''),
            });
        });
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/import',
            {data: JSON.stringify(final)},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                errCount: number,
                goodCount: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowProgressLoading();
                setClassSelected({
                    title: '',
                    id: 0,
                });
                fetchList(0, 'all');
                if (d.errCount > 0)
                    setTimeout(() => ShowSnackbar(`تعداد ${CurrencyFormat(d.goodCount)} افزوده شد و ${CurrencyFormat(d.errCount)} رکورد مشکل داشت.`, 'باشه', 5000), 400);
                else
                    setTimeout(() => ShowSnackbar(`تعداد ${CurrencyFormat(d.goodCount)} رکورد افزوده شد.`, 'باشه', 5000), 400);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [grades, setGrades] = useState([] as string[]);
    const [addEdit, setAddEdit] = useState({
        show: false,
        id: 0,
        edit: false,
    });
    const [removeStudent, setRemoveStudent] = useState({
        show: false,
        id: 0,
        name: '',
    });
    const executeRemoveStudent = () => {
        const x = {...removeStudent};
        const cls = {...classSelected};
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/remove',
            {
                id: x.id.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowProgressLoading();
                fetchList(cls.id, 'all');
                ShowSnackbar(
                    'دانش‌آموز موردنظر حذف گردید.',
                    'باشه',
                    5000,
                );
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded || list.length < 1)
            return;
        const filter = search.toUpperCase().trim();
        const lst = document.querySelector('.the-students-table');
        const btns = (lst as HTMLDivElement).getElementsByTagName('tr');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('a')[0];
            if (typeof b === "undefined")
                continue;
            const v = b.innerHTML.toUpperCase();
            const noSpace = v.replaceAll(' ', '');
            if (v.indexOf(filter) > -1 || noSpace.indexOf(filter.replaceAll(' ', '')) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const [classSelected, setClassSelected] = useState({
        id: 0,
        title: '',
    });
    const [classModal, setClassModal] = useState(false);
    const [profileModal, setProfileModal] = useState(false);
    const exportToExcel = () => {
        ShowProgressLoading();
        const _class = {...classSelected};
        PostJSON(
            Apis.server + '/core/admins/students/print',
            {
                classId: _class.id.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: printStudentsInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let cols = [
                    'نام',
                    'نام خانوادگی',
                    'پایه',
                    'کد ملی',
                    'نام پدر',
                    'سریال شناسنامه',
                    'تلفن منزل',
                    'تاریخ تولد',
                    'مدرک پدر',
                    'تلفن پدر',
                    'شغل پدر',
                    'نام مادر',
                    'تلفن مادر',
                    'مدرک مادر',
                    'شغل مادر',
                    'کد پستی',
                    'آدرس',
                    'موجودی بوفه',
                    'حداکثر خرید روزانه بوفه',
                    'وضعیت حضور',
                    'کلاس',
                ];
                for (let i = 0; i < cols.length; i++)
                    cols[i] = `"${cols[i]}"`;
                let csvList = cols.join(",");
                if (d.list !== null) {
                    const totalFound = d.list.length;
                    for (let i = 0; i < totalFound; i++) {
                        if (i === 0)
                            csvList += "\n";
                        if (i > 0 && i !== totalFound)
                            csvList += '\n';
                        let r = [
                            d.list[i].firstname,
                            d.list[i].lastname.toString(),
                            GradeToString(d.list[i].grade),
                            d.list[i].national,
                            d.list[i].father,
                            d.list[i].birthSerial,
                            d.list[i].homeTell,
                            GregorianToPersian(d.list[i].birthDate),
                            d.list[i].fatherCertificate,
                            d.list[i].fatherTell,
                            d.list[i].fatherJob,
                            d.list[i].motherName,
                            d.list[i].motherTell,
                            d.list[i].motherCertificate,
                            d.list[i].motherJob,
                            d.list[i].zipCode,
                            d.list[i].address,
                            d.list[i].budget.toString() + " تومان",
                            d.list[i].maxBuyPerDay.toString() + " تومان",
                            d.list[i].IsInside === 1 ? 'حاضر' : 'عایب',
                            d.list[i].className === '' ? '-' : d.list[i].className,
                        ];
                        for (let j = 0; j < r.length; j++)
                            r[j] = `"${r[j]}"`;
                        csvList += r.join(",");
                    }
                }
                var a = encodeURI('data:text/csv;charset=UTF-8,\uFEFF' + csvList);
                var link = document.createElement('a');
                link.setAttribute('href', a);
                link.setAttribute('download', 'students.csv');
                document.body.appendChild(link);
                link.click();
                ShowSnackbar(
                    'فایل اکسل دانلود شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'دانش‌آموزان', url: '/admins/students'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration="1000">
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>لیست دانش‌آموزان</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    {
                                        can.download ?
                                            <button onClick={exportToExcel}>
                                                <ThinCloudDownloadIcon/>
                                                <span>اکسل</span>
                                            </button> : null
                                    }
                                    <button onClick={() => setProfileModal(true)}>
                                        <ThinFilterIcon/>
                                        <span>{profileFilter === 'all' ? 'همه' : (profileFilter === 'complete' ? 'پرونده تکمیل' : 'نقص پرونده')}</span>
                                    </button>
                                    <button onClick={() => setClassModal(true)}>
                                        <ThinClassIcon/>
                                        <span>{classSelected.id > 0 ? classSelected.title : 'همه کلاس‌ها'}</span>
                                    </button>
                                    {
                                        can.addEdit ?
                                            <>
                                                <button onClick={() => setAddEdit({
                                                    show: true,
                                                    edit: false,
                                                    id: 0,
                                                })}>
                                                    <ThinAddIcon/>
                                                    <span>افزدون تکی</span>
                                                </button>
                                                <button onClick={() => setRenderExcel(true)}>
                                                    <ThinCloudUploadIcon/>
                                                    <span>آپلود از اکسل</span>
                                                </button>
                                            </>
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="pick-device-search">
                                <button><SearchIcon/></button>
                                <input type="text"
                                       value={search}
                                       onChange={e => setSearch(e.currentTarget.value)}
                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                       className="f-roboto"
                                       placeholder={"جستجو دانش‌آموز..."}
                                />
                            </div>
                            <table
                                className="table open-table table-striped table-hover table-bordered the-students-table">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>نام</th>
                                    <th>پایه</th>
                                    <th>کلاس</th>
                                    <th>کد ملی</th>
                                    <th>نام پدر</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"Ksi3riJaSd9" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>
                                                <Link to={"/admins/students/view/" + s.id}>
                                                    {(s.firstname + " " + s.lastname).replaceAll('ي', 'ی')}
                                                </Link>
                                            </td>
                                            <td>{GradeToString(s.grade)}</td>
                                            <td>{s.classId === 0 ? 'x' : s.className}</td>
                                            <td>{s.national}</td>
                                            <td>{s.father}</td>
                                            <td>
                                                <div className="d-inline-flex" style={{gap: 5}}>
                                                    <button className="open-tooltip"
                                                            onClick={() => window.open(window.location + `/view/${s.id}`)}>
                                                        <ThinOpenNewIcon/>
                                                        <i>مشاهده</i>
                                                    </button>
                                                    {
                                                        can.addEdit ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setAddEdit({
                                                                        show: true,
                                                                        edit: true,
                                                                        id: s.id,
                                                                    })}>
                                                                <ThinEditIcon/>
                                                                <i>ویرایش</i>
                                                            </button> : null
                                                    }
                                                    {
                                                        can.remove ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setRemoveStudent({
                                                                        show: true,
                                                                        id: s.id,
                                                                        name: s.firstname + " " + s.lastname,
                                                                    })}>
                                                                <ThinTrashIcon/>
                                                                <i>حذف</i>
                                                            </button> : null
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            {
                renderExcel ?
                    <ReactSpreadsheetImport
                        isOpen={true}
                        onClose={() => setRenderExcel(false)}
                        fields={[
                            {
                                label: 'نام',
                                key: 'firstName',
                                alternateMatches: ["اسم", 'اسم کوچک', 'نام'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "علی",
                                validations: [
                                    {
                                        rule: "required",
                                        errorMessage: "نام لازم است",
                                        level: "error",
                                    },
                                ],
                            },
                            {
                                label: 'نام خانوادگی',
                                key: 'lastName',
                                alternateMatches: ["فامیل", 'نام‌خانوادگی', 'نام خانواده', 'نام خانوادگی'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "احمدی",
                                validations: [
                                    {
                                        rule: "required",
                                        errorMessage: "نام خانوادگی لازم است",
                                        level: "error",
                                    },
                                ],
                            },
                            {
                                label: 'کد ملی',
                                key: 'national',
                                alternateMatches: ["شماره ملی", 'کدملی'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "0890451002",
                                validations: [
                                    {
                                        rule: "unique",
                                        errorMessage: "کد ملی تکراری است",
                                        level: "info",
                                    },
                                ],
                            },
                            {
                                label: 'پایه تحصیلی',
                                key: 'grade',
                                alternateMatches: ["مقطع", 'مقطع تحصیلی', 'پایه'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "اول ابتدایی",
                                validations: [
                                    {
                                        rule: "required",
                                        errorMessage: "پایه تحصیلی لازم است",
                                        level: "error",
                                    },
                                ],
                            },
                            {
                                label: 'شماره سریال شناسنامه',
                                key: 'birthSerial',
                                alternateMatches: ["سریال", 'شناسنامه'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "123",
                                validations: null,
                            },
                            {
                                label: 'تلفن منزل',
                                key: 'homeTell',
                                alternateMatches: ["تلفن خانه", 'شماره خانه', 'شماره منزل'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "05155212345",
                                validations: null,
                            },
                            {
                                label: 'تاریخ تولد',
                                key: 'birthDate',
                                alternateMatches: ["تولد"],
                                fieldType: {
                                    type: "input",
                                },
                                example: "1390/05/12",
                                validations: null,
                            },
                            {
                                label: 'نام پدر',
                                key: 'fatherName',
                                alternateMatches: ["پدر"],
                                fieldType: {
                                    type: "input",
                                },
                                example: "محمد",
                                validations: [
                                    {
                                        rule: "required",
                                        errorMessage: "نام پدر لازم است",
                                        level: "error",
                                    },
                                ],
                            },
                            {
                                label: 'مدرک تحصیلی پدر',
                                key: 'fatherCert',
                                alternateMatches: ["مدرک پدر"],
                                fieldType: {
                                    type: "input",
                                },
                                example: "لیسانس کامپیوتر",
                                validations: null,
                            },
                            {
                                label: 'تلفن همراه پدر',
                                key: 'fatherTell',
                                alternateMatches: ["شماره پدر", 'تلفن پدر'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "09123456789",
                                validations: null,
                            },
                            {
                                label: 'شغل پدر',
                                key: 'fatherJob',
                                alternateMatches: ["حرفه پدر", 'کار پدر'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "دبیر",
                                validations: null,
                            },
                            {
                                label: 'نام و نام خانوادگی مادر',
                                key: 'motherName',
                                alternateMatches: ["نام مادر"],
                                fieldType: {
                                    type: "input",
                                },
                                example: "مینو مینایی",
                                validations: null,
                            },
                            {
                                label: 'تلفن همراه مادر',
                                key: 'motherTell',
                                alternateMatches: ["تلفن مادر", 'شماره مادر'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "09123456789",
                                validations: null,
                            },
                            {
                                label: 'مدرک تحصیلی مادر',
                                key: 'motherCert',
                                alternateMatches: ["مدرک مادر"],
                                fieldType: {
                                    type: "input",
                                },
                                example: "فوق لیسانس حسابداری",
                                validations: null,
                            },
                            {
                                label: 'شغل مادر',
                                key: 'motherJob',
                                alternateMatches: ["حرفه مادر", 'کار مادر'],
                                fieldType: {
                                    type: "input",
                                },
                                example: "حسابدار",
                                validations: null,
                            },
                            {
                                label: 'کد پستی',
                                key: 'zipcode',
                                alternateMatches: ["کد پستی منزل"],
                                fieldType: {
                                    type: "input",
                                },
                                example: "1234567890",
                                validations: null,
                            },
                            {
                                label: 'نشانی',
                                key: 'address',
                                alternateMatches: ["آدرس"],
                                fieldType: {
                                    type: "input",
                                },
                                example: "کاشمر، خیابان جهموری ۴۷",
                                validations: null,
                            },
                        ]}
                        onSubmit={saveExcelData}
                        rtl={true}
                        customTheme={{
                            components: {
                                Button: {
                                    defaultProps: {
                                        colorScheme: "blue",
                                    },
                                },
                            },
                        }}
                        translations={{
                            uploadStep: {
                                title: "بارگیری فایل",
                                manifestTitle: "اطلاعات مورد انتظار:",
                                manifestDescription: "(در مرحله بعد می‌توانید نام ستون‌ها را تغییر دهید و یا آن‌ها را حذف کنید)", // You will have a chance to rename or remove columns in next steps
                                maxRecordsExceeded: (maxRecords: string) => `تعداد رکورد‌ها خیلی زیاد است. حداکثر ${maxRecords} مجاز است`, // `Too many records. Up to ${maxRecords} allowed
                                dropzone: {
                                    title: "فایل اکسل خود را وارد کنید",
                                    errorToastDescription: "آپلود منع گردید", // upload rejected
                                    activeDropzoneTitle: "فایل‌تان را اینجا رها کنید", // Drop file here...
                                    buttonTitle: "انتخاب فایل", // Select file
                                    loadingTitle: "در حال پردازش", // Processing...
                                },
                                selectSheet: {
                                    title: "برکه (شیت) موردنظر را انتخاب کنید", // Select the sheet to use
                                    nextButtonTitle: "بعدی",
                                },
                            },
                            selectHeaderStep: {
                                title: "سطر دارای عناوین را انتخاب کنید", // Select header row
                                nextButtonTitle: "بعدی",
                            },
                            matchColumnsStep: {
                                title: "بررسی ستون‌ها", // Match Columns
                                nextButtonTitle: "بعدی",
                                userTableTitle: "جدول شما",
                                templateTitle: "تبدیل می‌شود به",
                                selectPlaceholder: "انتخاب ستون...",
                                ignoredColumnText: "ستون نادیده گرفته شد", // Column ignored
                                subSelectPlaceholder: "انتخاب...",
                                matchDropdownTitle: "همخوانی",
                                unmatched: "همنخوانی ندارد",
                                duplicateColumnWarningTitle: "یک ستون دیگر انتخاب نشده", // Another column unselected
                                duplicateColumnWarningDescription: "ستون‌ها نمی‌توانند شبیه هم باشند", // Columns cannot duplicate
                            },
                            validationStep: {
                                title: "بازبینی اطلاعات", // Validate data
                                nextButtonTitle: "تایید نهایی",
                                noRowsMessage: "اطلاعاتی یافت نشد",
                                noRowsMessageWhenFiltered: "اطلاعات دارای خطایی نیست",
                                discardButtonTitle: "حذف سطرهای انتخاب شده",
                                filterSwitchTitle: "نمایش فقط سطرهای دارای خطا",
                            },
                            alerts: {
                                confirmClose: {
                                    headerTitle: "خروج از عملیات افزودن از اکسل",
                                    bodyText: "آیا مطمئن هستید؟ اطلاعات وارد شده شما ذخیره نخواهد شد.",
                                    cancelButtonTitle: "انصراف",
                                    exitButtonTitle: "خروج",
                                },
                                submitIncomplete: {
                                    headerTitle: "خطا تشخیص داده شد",
                                    bodyText: "هنوز سطرهایی دارای خطا می‌باشند، سطرهای دارای خطا در افزودن درنظر گرفته نخواهند شد.", // There are still some rows that contain errors. Rows with errors will be ignored when submitting.
                                    bodyTextSubmitForbidden: "هنوز سطرهایی دارای خطا هستند",
                                    cancelButtonTitle: "انصراف",
                                    finishButtonTitle: "باشه",
                                },
                                unmatchedRequiredFields: {
                                    headerTitle: "همه ستون‌ها همخوانی ندارند", // Not all columns matched
                                    bodyText: "هنوز ستون‌هایی لازمی وجود دارد که همخوانی ندارند و یا نادیده گرفته شده‌اند، آیا می‌خواهید ادامه دهید؟", // There are required columns that are not matched or ignored. Do you want to continue?
                                    listTitle: "ستون‌هایی که همخوانی ندارند:",
                                    cancelButtonTitle: "انصراف",
                                    continueButtonTitle: "ادامه",
                                },
                                toast: {
                                    error: "خطا",
                                },
                            },
                        }}
                    /> : null
            }
            <AddEditStudentModal
                active={addEdit.show}
                closeHandler={() => setAddEdit(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                studentId={addEdit.id}
                isEdit={addEdit.edit}
                onDone={() => {
                    ShowProgressLoading();
                    setClassSelected({
                        title: '',
                        id: 0,
                    });
                    const x = profileFilter;
                    fetchList(0, x);
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
            />
            <RemoveModal
                active={removeStudent.show}
                closeHandler={() => setRemoveStudent(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف دانش‌آموز"}
                desc={`آیا مطمئن هستید می‌خواهید دانش‌آموز ${removeStudent.name} را حذف کنید؟`}
                onRemove={executeRemoveStudent}
            />
            <SelectClassModal
                active={classModal}
                closeHandler={() => setClassModal(false)}
                onSelected={(id: number, title: string) => {
                    ShowProgressLoading();
                    setClassSelected({
                        title: "کلاس " + title,
                        id: id,
                    });
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    const x = profileFilter;
                    fetchList(id, x);
                }}
            />
            <AdminsStudentsProfileFilterModal
                active={profileModal}
                closeHandler={() => setProfileModal(false)}
                onDone={(d: 'all' | 'complete' | 'incomplete') => {
                    const i = classSelected.id;
                    fetchList(i, d);
                }}
                current={profileFilter}
            />
        </>
    );
};

export const GradeToString = (grade: number) => {
    switch (grade) {
        case 1:
            return "اول ابتدایی";
        case 2:
            return "دوم ابتدایی";
        case 3:
            return "سوم ابتدایی";
        case 4:
            return "چهارم ابتدایی";
        case 5:
            return "پنجم ابتدایی";
        case 6:
            return "ششم ابتدایی";
        case 7:
            return "اول متوسطه دوره اول";
        case 8:
            return "دوم متوسطه دوره اول";
        case 9:
            return "سوم متوسطه دوره اول";
        case 10:
            return "اول متوسطه دوره دوم";
        case 11:
            return "دوم متوسطه دوره دوم";
        case 12:
            return "سوم متوسطه دوره دوم";
        case 13:
            return "پیش دبستانی";
        default:
            return "نامشخص";
    }
};

export const GradeToNumber = (grade: string) => {
    switch (grade.trim()) {
        case "اول ابتدایی":
            return 1;
        case "دوم ابتدایی":
            return 2;
        case "سوم ابتدایی":
            return 3;
        case "چهارم ابتدایی":
            return 4;
        case "پنجم ابتدایی":
            return 5;
        case "ششم ابتدایی":
            return 6;
        case "اول متوسطه دوره اول":
            return 7;
        case "دوم متوسطه دوره اول":
            return 8;
        case "سوم متوسطه دوره اول":
            return 9;
        case "اول متوسطه دوره دوم":
            return 10;
        case "دوم متوسطه دوره دوم":
            return 11;
        case "سوم متوسطه دوره دوم":
            return 12;
        default:
            console.log(grade);
            return 0;
    }
};